import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    document.body.style.overflow = !isOpen ? "hidden" : "auto";
  };

  const isActivePage = (path) => {
    return location.pathname === path;
  };

  const navigationItems = [
    { path: "/", name: "Home" },
    { path: "/prizes", name: "Prizes" },
    { path: "/rules", name: "Rules" },
    { path: "/exe2025", name: "EXE 2025" },
    { path: "/submissions", name: "Submissions" },
    // { path: "/contact", name: "Contact" },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-[100] bg-exe-bg-primary/95 border-b border-exe-text-accent/20 backdrop-blur-md">
      <div className="exe-container">
        <div className="flex justify-between items-center py-3">
          {/* Logo and Title - Left aligned */}
          <motion.div
            className="flex items-center flex-shrink-0"
            whileHover={{ scale: 1.02 }}
            transition={{ duration: 0.2 }}
          >
            <Link to="/" className="flex items-center space-x-3">
              <div className="flex flex-col">
                <span className="text-2xl font-black text-exe-text-accent tracking-wider">
                  EXE
                </span>
                <span className="text-xs text-exe-text-secondary uppercase tracking-widest leading-none">
                  Flagship Game Dev Event
                </span>
              </div>
            </Link>
          </motion.div>

          {/* Desktop Navigation - Right aligned */}
          <div className="hidden lg:flex items-center space-x-2">
            <ul className="flex space-x-1 items-center">
              {navigationItems.map((item, index) => (
                <li key={index}>
                  <Link to={item.path}>
                    <motion.div
                      className={`px-4 py-2 rounded-lg transition-all duration-150 text-sm font-medium ${
                        isActivePage(item.path)
                          ? "bg-exe-text-accent/20 text-exe-text-accent"
                          : "text-exe-text-primary hover:text-exe-text-accent hover:bg-exe-text-accent/10"
                      }`}
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                    >
                      {item.name}
                    </motion.div>
                  </Link>
                </li>
              ))}
            </ul>

            {/* Register Button 
            <Link to="/register" className="ml-4">
              <motion.button
                className="exe-btn exe-btn-primary px-6 py-2 text-sm font-semibold"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Register Now
              </motion.button>
            </Link>*/}
          </div>

          {/* Mobile Menu Button */}
          <motion.button
            className="lg:hidden p-2 text-exe-text-primary hover:text-exe-text-accent transition-colors"
            onClick={toggleMenu}
            whileTap={{ scale: 0.95 }}
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {isOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </motion.button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.2 }}
            className="lg:hidden bg-exe-bg-secondary/98 backdrop-blur-md border-t border-exe-text-accent/20"
          >
            <div className="exe-container py-6">
              <ul className="space-y-3">
                {navigationItems.map((item, index) => (
                  <motion.li
                    key={index}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: index * 0.1 }}
                  >
                    <Link
                      to={item.path}
                      onClick={() => {
                        setIsOpen(false);
                        document.body.style.overflow = "auto";
                      }}
                      className={`block px-4 py-3 rounded-lg transition-all duration-150 font-medium ${
                        isActivePage(item.path)
                          ? "bg-exe-text-accent/20 text-exe-text-accent"
                          : "text-exe-text-primary hover:text-exe-text-accent hover:bg-exe-text-accent/10"
                      }`}
                    >
                      {item.name}
                    </Link>
                  </motion.li>
                ))}

                {/* Mobile Register Button 
                <motion.li
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: navigationItems.length * 0.1 }}
                  className="pt-4 border-t border-exe-text-accent/20"
                >
                  <Link
                    to="/register"
                    onClick={() => {
                      setIsOpen(false);
                      document.body.style.overflow = "auto";
                    }}
                    className="block"
                  >
                    <motion.button
                      className="exe-btn exe-btn-primary w-full font-semibold"
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                    >
                      Register Now
                    </motion.button>
                  </Link>
                </motion.li>*/}
              </ul>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;
